import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import {Observable} from 'rxjs';
import {ExitReportGuardService} from '../services/exit-report-guard.service';

@Injectable({
  providedIn: 'root'
})
export class ExitReportConfirmationGuard implements CanDeactivate<Observable<boolean>> {

  constructor(
    private readonly _exitReportGuardService: ExitReportGuardService
  ) {}

  canDeactivate(): Observable<boolean> {
    return this._exitReportGuardService.canExitWithoutSaved$;
  }

}
